import sleep from "@insite/client-framework/Common/Sleep";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadLists,
} from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import loadWishLists from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishLists";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";

replaceInChain(chain, LoadLists, async props => {
    const state = props.getState();
    const getWishListsParameter = state.components.addToListModal.getWishListsParameter;
    const session = state.context.session;
    if (
        props.parameter.modalIsOpen &&
        (session.isAuthenticated || session.rememberMe) &&
        !getWishListsDataView(state, getWishListsParameter).value
    ) {
        props.dispatch(loadWishLists(getWishListsParameter));

        for (let x = 0; x < 200; x += 1) {
            if (getWishListsDataView(props.getState(), getWishListsParameter).value) {
                break;
            }
            await sleep(50);
        }
    }
});
